jQuery(document).ready(function() {
 jQuery("div.open-bio").click(function() {
   jQuery(this).next('.bio-more').toggle();
   jQuery(this).toggleClass('active');
 });

 jQuery(window).on('resize', function() {
   var headerHeight = jQuery('header[data-section-id="header"]').outerHeight();
   jQuery('main.layout--main-content').css('margin-top', headerHeight+'px');
 }).resize();
});


$('.owl-carousel.reviews').owlCarousel({
   loop:true,
   items:3,
   nav:true,
   mouseDrag: true,
   responsiveClass: true,
   responsive:{
       0:{
           items:1
       },
       550:{
           items:2
       },
       768:{
           items:3
       }
   }
})


if(jQuery( window ).width() < 768)
{  
 jQuery('.footer--block--container').click(function() 
 {
  jQuery(".footer--block--heading").toggleClass('active');
  jQuery(this).closest("div").find("ul").toggleClass('show');
 });
}


jQuery(document).on('change', '.collection_swatches .swatch input[type="radio"]', function() 
{
 var variant_image1 = jQuery(this).data('variant_image1'),
     variant_image2 = jQuery(this).data('variant_image2'),
     variant_url = jQuery(this).data('variant_url');

 jQuery(this).parents('.product--root').find('a').attr('href', variant_url);

 if(typeof variant_image1 != 'undefined') {
   jQuery(this).parents('.product--root').find('.image--root img.lazyautosizes.lazyloaded').attr('srcset', variant_image1);
 }
 if(typeof variant_image2 != 'undefined' && !variant_image2.includes('no-image')) {
   jQuery(this).parents('.product--root').find('.image--root img.hidden').attr('src', variant_image2);
 } else {
   jQuery(this).parents('.product--root').find('.image--root img.hidden').attr('src', variant_image1);
 }
});


jQuery((function(e) {
 e("a.topopup").click((function() 
 {
   return setTimeout((function() 
   {
     s()
   }
    ), 500),
    !1
}
)),
e("div.close").click((function() {
    o()
}
)),
e(this).keyup((function(e) {
    27 == e.which && o()
}
)),
e("div#backgroundPopup").click((function() {
    o()
}
));
var i = 0;
function s() 
{
    0 == i && (e("#toPopup").fadeIn(320),
    e("#backgroundPopup").css("opacity", "0.7"),
    e("#backgroundPopup").fadeIn(1),
//      e("header").css("display", "none"),
    e('header').addClass('fixed-pop'),
    e('main').addClass('fixed-pop-main'),
    e('body').css('overflow', 'hidden'), //Adeed
    e('body').css('overflow-y', 'hidden'), //Adeed
    i = 1)
}
function o() 
{
    1 == i && (e("#toPopup").fadeOut("normal"),
    e("#backgroundPopup").fadeOut("normal"),
    e('header').removeClass('fixed-pop'), 
    e('main').removeClass('fixed-pop-main'),           
    e("header").css("display", "block"),
    e('body').css('overflow', 'auto'), //Adeed
    e('body').css('overflow-y', 'auto'), //Adeed
    i = 0)
}
e(".all_sizes_slider .single-size.active").owlCarousel({
    loop: !0,
    items: 1,
    arrows: !0,
    nav: !0,
    mouseDrag: !0,
    responsiveClass: !0,
    singleItem: true,
    navigation: !0,
    //navigationText: ["<div class='nav-btn prev-slide'>&#8592;</div>", "<div class='nav-btn next-slide'>&#8594;</div>"],
    responsive: {
        0: {
            items: 1,
            loop: !0
        }
    }
}),
  
e(".config__size-row .config__radio-item").click((function() 
{
    e(".config__radio-item").removeClass("active"),
    e(".all_sizes_slider .single-size").removeClass("active");
    var i = e(this).data("size");
    e('.all_sizes_slider .single-size[data-size="' + i + '"]').addClass("active"),
    e(".all_sizes_slider .single-size.active").owlCarousel({
        loop: !0,
        items: 1,
        arrows: !0,
        nav: 1,
        mouseDrag: !0,
        responsiveClass: !0,
        navigation: !0
        //navigationText: ["<div class='nav-btn prev-slide'>&#8592;</div>", "<div class='nav-btn next-slide'>&#8594;</div>"]
    }),
    e(this).addClass("active"),
    e(this).find("input[type=radio]").prop("checked", !0)
}
))
}));


$(document).ready(function(){
 $('.collection_swatches .ctm-color input').removeAttr('checked');
 $('.collection_swatches .preselected label').trigger('click');
});

jQuery(document).ready(function() {
 var currentURL = window.location.href; 
 if(currentURL.includes('products')) {
   setTimeout(function() {
     $('.collection_swatches .preselected label').trigger('click');
   }, 2000);
 } else {
   $('.collection_swatches .preselected label').trigger('click');
 }
});




$(document).ready(function() 
 {
   $('.slideRight').click(function(event) 
   {
     $(this).hide();
     $(this).parents('.collection_swatches').find('.swatch').css('max-width', '100%');
     $(this).parents('.collection_swatches').find('.swatch').animate({scrollLeft: 200}, 800);
   });
 
   $('.collection_swatches .swatch').scroll(function() 
   {
      $(this).css('max-width', '100%');
      $(this).parents('.collection_swatches').find('.slideRight').hide();
   });
 });







//Currency Converter
  class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define('localization-form', LocalizationForm);



jQuery( document ).ready(function() 
{
  if(jQuery(window).width() > 768 )
  {
    let ele  = jQuery('.add-to-cart-panel span.actual-price.money')[0];
    let resizeObserver = new ResizeObserver((e) => 
    {
      //console.log("The element was resizedDD");
      let txt = jQuery(ele).text();
      txt = txt.replace('$','');
      txt = txt.replace('£','');
      txt = txt.replace('GBP','');
      txt = txt.replace('CAD','');
      txt = txt.replace('AUD','');  

      txt = parseFloat(parseInt(txt)/4).toFixed(2);
      txt = 'or 4 interest-free payments of $'+txt+' with ';
      txt = txt.replace('0with','0 with');  

      document.querySelector('#shopify-section-product-color-group afterpay-placement').shadowRoot.querySelector('p > span.afterpay-main-text').textContent = txt;
      
    });
    resizeObserver.observe(ele);
  }

  jQuery('#shopify-section-product-color-group .product-header .price span.actual-price.money').on('DOMSubtreeModified', function(e)
  {
    let txt = jQuery(this).text();
    txt = txt.replace('$', '');
    txt = txt.replace('£', '');
    txt = txt.replace('GBP', '');
    txt = txt.replace('CAD', '');
    txt = txt.replace('AUD', '');

    txt = parseFloat(parseInt(txt)/4).toFixed(2);
    txt = 'or 4 interest-free payments of $'+txt+'with ';
    txt = txt.replace('0with','0 with');  
    
    document.querySelector('#shopify-section-product-color-group .product-header  afterpay-placement').shadowRoot.querySelector('p > span.afterpay-main-text').innerHTML = txt;
  });

});

jQuery( document ).ready(function(){
  $('section.product-grid > .block h2.title').each(function(index, ele) {
    let h = $(this).html().trim(); // Trim leading and trailing whitespaces
    if (h !== null && h !== undefined && typeof h === 'string') {
      h = h.replace('- Short', '');
      h = h.replace('- Regular/Long', '');
      h = h.replace('- XLong', '');
      
      // Check if the trimmed title starts with "Lacey" and if so, add "Lacey -" at the beginning
      if (h.startsWith('Lacey')) {
        h = 'Lacey - ' + h.substr(6).trim(); // Trim again after removing "Lacey"
      }
      $(this).html(h);
   }
 });

  var value = new Date().getTimezoneOffset().toString();
  $('input[name="properties[__shopify_offset]"]').attr('value', value);

  $('.recipient__checkbox').on('click',function(){
    if($(this).is(':checked')) {
      $('.recipient-fields').slideDown();
    } else {
      $('.recipient-fields').slideUp();
    }
  });
});
